export default () => {
  return {
    default: {
      wrap: {
        button: {
          background: 'none',

          '&:hover': {
            color: '#666666',
          },
        },
      },
    },

    dark: {
      wrap: {
        button: {
          color: 'white',

          '&:hover': {
            color: 'white',
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
          },

          '&:active': {
            backgroundColor: 'rgba(255, 255, 255, 0.35)',
          },
        },
      },
    },
  } as const
}
